const DEFAULT_PROD_API_BASE = 'https://telegram-ai-chat-miniapp-worker.happy-creature91.workers.dev';
const DEFAULT_DEV_API_BASE = 'http://localhost:4000';

const defaultBase = import.meta.env.DEV ? DEFAULT_DEV_API_BASE : DEFAULT_PROD_API_BASE;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? defaultBase;
